<template>
  <non-property-layout>
    <Loading v-if="isLoading" />
    <div class="flex flex-col justify-center min-h-600">
      <!-- component -->
      <div
        class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
      >
        <div class="px-8 py-8 rounded-xl">
          <h1 name="login-title" class="mt-2 text-center font-bold text-2xl">Confirm Email</h1>

          <ErrorDisplay
            :label="confirmationErrorLabel"
            :message="confirmationError"
            :isVisible="confirmationError != null"
          />

          <div v-if="confirmationRequestSuccess" class="bg-green-200 my-6 p-4">
            <h1 class="text-xl font-bold">Email confirmation successful</h1>
            <p v-if="property?.siteCode">
              <router-link :to="`/${property?.siteCode}`"
                >Click here to begin using SafetyNet</router-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </non-property-layout>
</template>
<script setup lang="ts">
import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";

const userStore = useUserStore();

const router = useRouter();
const route = useRoute();
const bldgStore = useBldgStore();

let isLoading = ref(true);
let code: string | null = null;
let username: string | null = null;
var property = computed(() => bldgStore.property);

onMounted(loadData);
onActivated(() => loadData);
async function loadData() {
  console.log("Confirm Email page loaded");

  isLoading.value = true;
  confirmationRequestSuccess.value = false;

  await router.isReady();

  //Read code param
  let codeParam = route.query["code"];
  if (codeParam) code = Array.isArray(codeParam) ? codeParam[0] : codeParam;

  if (!code || code.length < 100) {
    confirmationErrorLabel.value = "Invalid link";
    confirmationError.value =
      "There is an error with your confirmation link. Please close this tab and click the link in the email again";
  }

  //Read username param
  let usernameParam = route.query["user"];
  if (usernameParam) username = Array.isArray(usernameParam) ? usernameParam[0] : usernameParam;

  if (!username || username.length < 5) {
    confirmationErrorLabel.value = "Invalid link";
    confirmationError.value =
      "There is an error with your confirmation link. Please close this tab and click the link in the email again";
  }

  await confirmEmail();

  isLoading.value = false;
}

let confirmationErrorLabel = ref<string | null>(null);
let confirmationError = ref<string | null>(null);
let confirmationRequestSuccess = ref(false);

async function confirmEmail() {
  console.log(`Requesting email confirmation for ${username}`);
  confirmationRequestSuccess.value = false;
  confirmationError.value = null;
  confirmationErrorLabel.value = null;

  let resultError = await userStore.verifyEmail(username, code);

  if (resultError && resultError.length > 0) {
    confirmationErrorLabel.value = "Couldn't Confirm Email";
    confirmationError.value = resultError;
    confirmationRequestSuccess.value = false;
  } else {
    confirmationRequestSuccess.value = true;
  }

  //refresh user
  await userStore.getUser(property.value.siteCode, property.value.portalId, true);
}
</script>
